export const DRAG = 30;
export const RESIZE_MIN = 100;
